import store from 'services/store';
import setAuth from '../actions/setAuth';

const setAuthInfo = async authInfo => await store.dispatch(setAuth(authInfo.auth));

export default setAuthInfo;
